const safeFileName = value => String(value || 'document')
  .replace(/[\\/:*?"<>|]+/g, '_')
  .trim() || 'document';

export async function downloadDocument(url, fileName) {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    if (!response.ok) throw new Error(`Download failed with status ${response.status}`);

    const objectUrl = URL.createObjectURL(await response.blob());
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = safeFileName(fileName || url.split('/').pop());
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
  } catch {
    if (/\/api\/tenant\/[^/]+\/certificates\/\d+\/documents\/[a-f0-9]{24}(?:$|[?#])/i.test(String(url || ''))) {
      throw new Error('Protected document download failed');
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
